import { ImageOptions } from './optimized-image.types';

export function generateURL({
  src,
  width,
  height,
  aspectRatio,
  format,
  quality,
  blur,
  fit,
  crop,
}: ImageOptions): string {
  const params = [];
  const imgSrc = src ? src : 'https://images.xceed.me/static/entities/event-place-holder.jpg';

  if (width) params.push(`w=${width}`);
  if (height) params.push(`h=${height}`);
  if (aspectRatio) params.push(`ar=${aspectRatio}`);
  if (format) params.push(`fm=${format}`);
  if (quality) params.push(`q=${quality}`);
  if (blur) params.push(`blur=${blur}`);
  if (fit) params.push(`fit=${fit}`);
  if (crop) params.push(`crop=${crop}`);

  const paramString = params.length > 0 ? `?${params.join('&')}` : '';

  const transformedImageUrl = `${imgSrc}${paramString}`;
  return transformedImageUrl;
}
